module.exports = __webpack_public_path__ + "img/Comic02-5.ae517918.png";